import { render, staticRenderFns } from "./components-group-template.vue?vue&type=template&id=6133d7ff"
import script from "./components-group-template.vue?vue&type=script&lang=js"
export * from "./components-group-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports